import { ITableMeta } from '../../../../utils/apollo/graphqlSchema';
import {
  ViewHeaderDiv,
  ViewHeaderTableRow,
  ViewTablesWrapperDiv,
} from './SchemaEntityRelationsUI';
import KubitTooltip from '../../../../components/KubitTooltip';
import React from 'react';

interface IProps {
  viewKey: string;
  viewTables: ITableMeta[];
}
const ViewHeader = ({ viewKey, viewTables }: IProps) => {
  return (
    <>
      <ViewHeaderDiv>{viewKey}</ViewHeaderDiv>
      <ViewTablesWrapperDiv>
        {viewTables.map((tableMeta) => {
          const value = `Table: ${tableMeta.name} (${tableMeta.key})`;
          return (
            <KubitTooltip key={tableMeta.key} content={value} placement="right">
              <ViewHeaderTableRow>{value}</ViewHeaderTableRow>
            </KubitTooltip>
          );
        })}
      </ViewTablesWrapperDiv>
    </>
  );
};

export default ViewHeader;
